export default __webpack_public_path__ + "static/media/hessahStore7.6b0e4277.jpg";